module.exports = __webpack_public_path__ + "static/img/pad4.74599f12.png";